import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Channel, useChannelContext } from 'scbk-services';
// import { Loading } from 'scbk-ui-web';
import { useGetPublicKey } from '../hooks/useGetKeypadPublicKey';

/**
 * native keypad 컨텍스트 Props
 */
interface NFIlterPublicKeyContextProps {
  publicKey: string;
  encodePublicKey: string;
  initPublicKey: () => Promise<void> | void;
}

/**
 * native keypad 컨텍스트 생성
 */
const NFIlterPublicKeyContext = createContext<NFIlterPublicKeyContextProps>({
  publicKey: '',
  encodePublicKey: '',
  initPublicKey: () => {},
});

/**
 * 채널 컨텍스트 hook
 * @returns
 */
const useNFilterPublicKeyContext = () => {
  const context = useContext(NFIlterPublicKeyContext);
  // if (!context) throw new Error('useNativeKeypad must be used within NFIlterPublicKeyContextProvider');
  return context;
};

/**
 *
 * @param param0
 * @returns
 */
const NFilterPublicKeyProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { channel } = useChannelContext();

  const { publicKey } = useGetPublicKey();

  const [ready, setReady] = useState(false);

  const nFilterPublicKey = useRef<string>('');
  const encodeNFilterPublicKey = useRef<string>('');
  const mountedRef = useRef<boolean>(false);

  const initPublicKey = useCallback(async () => {
    if (channel === Channel.MB) {
      nFilterPublicKey.current = await publicKey();
      encodeNFilterPublicKey.current = encodeURIComponent(nFilterPublicKey.current);
    }

    setReady(true);
  }, [channel, publicKey, setReady]);

  useEffect(() => {
    if (!channel) {
      return;
    }

    if (mountedRef.current) {
      return;
    }

    mountedRef.current = true;

    initPublicKey();
  }, [channel, publicKey]);

  if (!ready) {
    return null;
  }

  return (
    <NFIlterPublicKeyContext.Provider
      value={{
        publicKey: nFilterPublicKey.current,
        encodePublicKey: encodeNFilterPublicKey.current,
        initPublicKey,
      }}
    >
      {children}
    </NFIlterPublicKeyContext.Provider>
  );
};

export { NFilterPublicKeyProvider, useNFilterPublicKeyContext };
